export default __webpack_public_path__ + "static/start-up-7cb7062d641907f9f94b9f1ef20d651d.jpg";